import Vue from 'vue';
import ConfirmDeleteModal from '@/components/ConfirmDeleteModal.vue';

export interface ConfirmDeleteOptions {
    title?: string;
    okTitle?: string;
    cancelTitle?: string;
    countdownSeconds?: number;
    /** Rendered in bold at the {name} placeholder in the message. */
    name?: string;
}

export default function confirmDeleteDialog(parent: Vue, message: string, options: ConfirmDeleteOptions = {}): Promise<boolean> {
    return new Promise((resolve) => {
        const modal = new ConfirmDeleteModal({
            parent,
            propsData: { message, ...options },
        });

        modal.$on('done', (confirmed: boolean) => {
            modal.$destroy();
            modal.$el.remove();
            resolve(confirmed);
        });

        modal.$mount();
        document.body.appendChild(modal.$el);
    });
}
